
export function pageTitle(title){
	return `${title} - TRCA Real Time Gauging `
}